import { keepPreviousData } from '@tanstack/react-query';
import { TableState } from '@optimus-web/core';
import { useCurrentEnterpriseId } from '@mews-commander/core';
import {
    PortfolioEnterpriseRelationshipFilters,
    PortfolioEnterpriseRelationshipResult,
    StringFilterType,
    useRepositoryQuery,
} from '@mews-commander/data-access';

export const useGetProperties = (
    filtersState: TableState<PortfolioEnterpriseRelationshipResult, PortfolioEnterpriseRelationshipFilters>
) => {
    const enterpriseId = useCurrentEnterpriseId();
    const { filters, pagination, globalFilters, sort } = filtersState;

    return useRepositoryQuery(
        'portfolioEnterpriseRelationships',
        'getAll',
        {
            filters,
            pagination,
            sort,
            ...(globalFilters.search && {
                globalSearchFilter: { value: globalFilters.search, filterType: StringFilterType.Contains },
            }),
            enterpriseId,
        },
        { placeholderData: keepPreviousData }
    );
};
